export const _setNotificationBadge = (state, action) => {
  state.notificationBadge = action.payload;
};
